import React from "react";
import SVG from "react-inlinesvg";

const Icon = React.memo(function Icon({ url, source, top = "0", marginTop = "0", width = 30, height, left }) {
  switch (source) {
    case "editor":
      url = "/assets/noun_editor_2851392.svg";
      break;
    case "multiverse":
    case "guidedWormhole":
      url = "/assets/wormhole.svg";
      break;
    case "description":
    case "visualize":
      url = "/assets/describe-icon.svg";
      break;
    case "twist":
      url = "/assets/twist-icon.svg";
      break;
    case "character":
      url = "/assets/character-icon.svg";
      break;
    case "poem":
      url = "/assets/poem-icon.svg";
      break;
    case "rewrite":
      url = "/assets/rewrite-icon.svg";
      break;
    case "brainstorm":
      url = "/assets/brainstorm-icon.svg";
      break;
    case "plugin":
      url = "/assets/plugin.svg";
      break;
    case "myVoiceRewrite":
      url = "/assets/myVoiceRewriteIcon.svg";
      break;
    case "command":
    case "quickEditRestore":
      url = "/assets/command.svg";
      break;
    case "expand":
      url = "/assets/expand-card-icon.svg";
      break;
    case "write":
      url = "/assets/write.svg";
      break;
      }

  if (top) {
    top = `${top}px`;
  }

  if (marginTop) {
    top = `${marginTop}px`;
  }

  if (width) {
    width = `${width}px`;
  }

  if (height) {
    height = `${height}px`;
  }

  if (left) {
    left = `${left}px`;
  }

  return <SVG width={width} height={height} top={5} src={url} style={{ top: top, left: left, width: `${width}px`, height: `${height}px` }} />;
});

export default Icon;
